export default __webpack_public_path__ + "static/media/😇.8d12c8ce.svg";